const scope = {
    name_exists: 'Le nom de portée {{name}} est déjà utilisé',
    name_with_space: "Le nom de la portée ne peut pas contenir d'espace.",
};
export default Object.freeze(scope);
